import React, { useState, useEffect } from 'react';
import './SettingsPage.css';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from "antd";
import UserHeader from "../../components/header/UserHeader";
import TermsModal from '../../pages/onboarding/TermsModal';
import UserDrawer from "../../components/drawer/UserDrawer";
import aboutMyFriend from "../../assets/images/about-mf.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import contactUS from "../../assets/images/email-1.svg";
import { getPlanDetails } from '../../api/password';
import VersionPopup from '../../components/VersionPopup/VersionPopup';
import softwareIcon from "../../assets/images/Software.svg";
import privacyIcon from "../../assets/images/privacy.svg";
function SettingsPage() {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [planType, setPlanType] = useState('Free Plan');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [versionModalVisible, setVersionModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const showVersionModal = () => {
    setVersionModalVisible(true);
  };
  const handleClose = () => {
    setIsModalVisible(false);
  };
  const handleClose2 = () => {
    setVersionModalVisible(false)
  };
  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  const handleBack = () => {
    navigate("/landing-page");
  };

  const getSubscriptionStatus = (planType) => {
    switch (planType) {
      case 'Free Plan':
        return { label: 'Trial', color: '#809FB8', className: 'trial' };
      case 'Yearly Plan':
        return { label: 'Yearly', color: '#78A76B', className: 'yearly' };
      case 'Cancelled':
        return { label: 'Cancelled', color: '#D8646B', className: 'cancelled' };
      case 'Monthly Plan':
      default:
        return { label: 'Monthly', color: '#78A76B', className: 'monthly' };
    }
  };

  function handleFeedback() {
    navigate("/feedback");
  }

  function handleTermsAndConditions() {
    showModal();
  }

  function handleContactUs() {
    navigate("/feedback");
  }

  function handleVersion() {
    showVersionModal();
  }
  function handlePrivacyPolicy() {
    window.open("https://www.strategiadatasciences.com/privacy-policy/");
  }


  const { label, color, className } = getSubscriptionStatus(planType);

  useEffect(() => {
    const fetchPlanType = async () => {
      try {
        const response = await getPlanDetails();

        if (response.error) {
          console.error("Error fetching plantype:", response.error);
        } else {
          if (response.status === "canceled") {
            setPlanType("Cancelled");
          } else {
            setPlanType(response.planName);
          }
        }
      } catch (error) {
        console.error("Error fetching plantype:", error);
      }
    };

    fetchPlanType();
  }, []);

  return (
    <div style={{ minHeight: "100dvh", background: "#fefcfe" }}>
      <Col xs={24} sm={24} lg={24} md={24} style={{ transition: "opacity 0.3s ease, pointer-events 0.3s ease", opacity: isDrawerOpen ? "0.5" : "1", pointerEvents: isDrawerOpen ? "none" : "auto" }}>
        <Row justify={{ xs: "space-around", md: "space-around", lg: "space-between" }} style={{ marginBottom: 20 }}>
          <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
            <UserHeader setDrawer={openDrawer} />
          </Col>
          {isDrawerOpen && (
            <Col span={4}>
              <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
            </Col>
          )}

          <button onClick={handleBack} className="text-left pl-4 button-styling setBackButton">
            <img src={goBackButton} alt="Go Back Button" />
          </button>
        </Row>
        <div className="settings-container">
          <h1 className="settings-header">About MyFriend</h1>

          <div className="section-settings">
            <div className="section-header">HELP AND SUPPORT</div>
            <Row gutter={[16, 16]} className="section-item">
              <Col xs={24} sm={12} md={5}>
                <div onClick={handleContactUs} className="link-text"><span><img src={contactUS} alt="Contact Us" className="icon-settings" /></span>Contact Us</div>
              </Col>
              <Col xs={24} sm={24} md={19} className="md-text-right">
                <span onClick={handleFeedback} className="settings-link">
                  Have any feedback? We would love to hear it. Drop us an email here.
                </span>
              </Col>
            </Row>  
            <div className="section-item">
              <img src={aboutMyFriend} alt="Terms and Conditions" className="icon-settings" />
              <div onClick={handleTermsAndConditions} className="link-text">Terms and Conditions</div>
            </div>
            <div className="section-item">
              <img src={privacyIcon} alt="My Preferences" className="icon-settings" />
              <div onClick={handlePrivacyPolicy} to="/my-preferences" className="link-text">Privacy Policy</div>
            </div>
            <div className="section-item">
              <img src={softwareIcon} alt="My Profile" className="icon-settings" />
              <div onClick={handleVersion} to="/my-profile" className="link-text">Software Version</div>
            </div>
            
          </div>
        </div>
      </Col>

      {isModalVisible && <TermsModal visible={isModalVisible} onClose={handleClose} />}
      {versionModalVisible && <VersionPopup visible={versionModalVisible} onClose={handleClose2} />}

    </div>
  );
}

export default SettingsPage;
